// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__3McN3","clinicsSelect":"TableHeading_clinicsSelect__Xg1Ha"};